import React from "react";

const Footer = () =>{
    return <div className="footerStart">
    <footer>
        <div>
            <h4>Jinix Services</h4>
            <p>@all right reserved</p>
        </div>

        <div>
            <h6>Follow us</h6>
                <div>

                    <a href="https://github.com/jitendraKhadoliya" target="_blank" rel="noopener noreferrer">Github</a>
                    <a href="http://www.instagram.com/jitendra.khadoliya" target="_blank" rel="noopener noreferrer">Instagram</a>
                    <a href="https://www.linkedin.com/in/jitendrakhadoliya/" target="_blank" rel="noopener noreferrer">Linkedin</a>
                </div>
        </div>
    </footer>
    </div>
}

export default Footer;